import { render, staticRenderFns } from "./VRContainer.vue?vue&type=template&id=040ff76b"
import script from "./VRContainer.vue?vue&type=script&lang=js"
export * from "./VRContainer.vue?vue&type=script&lang=js"
import style0 from "./VRContainer.vue?vue&type=style&index=0&id=040ff76b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports